import type { ProjectRow, ProjectTagRow } from '@/types/api'

/**
 * Метки по проектам из ответа GET /projects/ (поле tags у каждого проекта).
 * Один запрос списка проектов вместо N× GET /projects/{id}/tags.
 */
export function buildTagsByProjectIdFromProjects(projects: ProjectRow[]): Map<string, ProjectTagRow[]> {
  const m = new Map<string, ProjectTagRow[]>()
  for (const p of projects) {
    m.set(p.id, Array.isArray(p.tags) ? p.tags : [])
  }
  return m
}
